import React from 'react'

export const D2DSidebarIcon = ({ isActive }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 5V20H5V4.5L14 2.5V5ZM14 5H19V20H21.5"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="11" cy="12" r="1" fill="#1D2943" />
  </svg>
)
